import React, { useEffect, useState } from 'react'
import { Typography, withStyles, CircularProgress } from '@material-ui/core'
import { Settings, FileUpload } from './components'
import { CoreButton, CoreTextField } from 'src/components/core'
import styles from './styles'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { track } from '@amplitude/analytics-browser'
import { Icon } from '@iconify/react'
import {
  aICreatorGenerateOutlineAction,
  aICreatorGenerateCourseAction,
  aICreatorUpdateOutlineAction,
  aICreatorUploadAttachmentSuccess,
} from 'src/reducers/ai-creator/action'
import Outline from './components/outline'
import AiCourseReady from '../create-course-with-ai/ai-course-ready'
import AiLoading from './components/course-creating-loader'
import { getCourseCreationProgressAction } from 'src/reducers/course/action'
import {
  componentBoxHideAction,
  componentBoxShowAction,
} from 'src/reducers/component-box/action'
import ComponentBoxContent from 'src/model/component-box'

import RecentFiles from './components/recent-files'
import UpgradeAiCreatorBanner from 'src/components/upgrade-ai-creator'

import { LimitTypeEnum } from 'src/model/limit'
import AiCreationLimitModal from 'src/components/ai-creation-limit-modal'
import UserType from 'src/model/user-types'
import BackButton from '../create-course-selection/components/back-button/back-button'
import { userLimitsGetAction } from 'src/reducers/user-limits/action'
import {
  selectUserLimits,
  selectCurrentCredits,
} from 'src/reducers/user-limits/selector'

const CreateCourseWithAIUseDocs = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const userLimits = useSelector(selectUserLimits)
  const currentCredits = useSelector(selectCurrentCredits)

  const [description, setDescription] = useState('')
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const courseCollectionId = searchParams.get('collectionId')
  const attachments = useSelector(state => state.aICreator.attachments)
  const [attachmentLoading, setAttachmentLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [settings, setSettings] = useState([])
  const [progress, setProgress] = useState(0)
  const [progressOutline, setProgressOutline] = useState(0)
  const [finished, setFinished] = useState(false)
  const [outlineId, setOutlineId] = useState()
  const [creditCost, setCreditCost] = useState()
  const [courseData, setCourseData] = useState()
  const [limitLoading, setLimitLoading] = useState(true)
  const [roleType, setRoleType] = useState()
  const [refreshesAt, setRefreshesAt] = useState()

  const [outline, setOutline] = useState()
  const attachmentsToCheck = attachments.filter(
    attachment =>
      attachment.succeeded === false &&
      attachment.upload_status !== 'partial_failure' &&
      attachment.upload_status !== 'failed',
  )
  const placeholder = 'What should be the title?'

  useEffect(() => {
    const inputBase = document.getElementById('title-input')
    if (inputBase) {
      inputBase.focus()
    }

    if (!userLimits) {
      dispatch(userLimitsGetAction())
    }
    dispatch(aICreatorUploadAttachmentSuccess())
  }, [dispatch, userLimits])

  useEffect(() => {
    if (userLimits) {
      setLimitLoading(true)
      const aiLimitData = userLimits.find(
        x => x.limit.type === LimitTypeEnum.AICourseCreation,
      )

      if (aiLimitData) {
        const refreshedAt = aiLimitData.refreshedAt
        setRoleType(userLimits[0].limit.roleType)
        setRefreshesAt(refreshedAt)
      }
      setLimitLoading(false)
    }
  }, [userLimits])

  useEffect(() => {
    let newProgressOutline = progressOutline < 95 ? progressOutline : 85
    if (newProgressOutline > 0) {
      const timer = setTimeout(() => {
        setProgressOutline(newProgressOutline + 1)
      }, 1000)

      return () => {
        clearTimeout(timer)
      }
    }
  }, [progressOutline])

  const generateOutline = () => {
    track('started_building_course')
    setLoading(true)

    setProgressOutline(progressOutline + 1)

    let attachmentIds = attachments.map(x => x.attachment_id)
    const transformedSettingObject = settings.reduce((acc, item) => {
      acc[item.key] = item.value
      return acc
    }, {})

    dispatch(
      aICreatorGenerateOutlineAction(
        {
          topic: description,
          attachmentIds: attachmentIds,
          documentFollowing:
            attachmentIds.length > 0
              ? transformedSettingObject.documentFollowing
              : null,
          ...transformedSettingObject,
        },
        response => {
          setLoading(false)
          setOutline(response.outline)
          setCreditCost(response.credit_cost)
          setOutlineId(response.outlineId)
        },
      ),
    )
  }
  const updateOutline = data => {
    setOutline(data)
    dispatch(aICreatorUpdateOutlineAction({ outline: data }, outlineId))
  }

  const settingsChangeHandler = value => {
    setSettings(value)
  }

  const generateCourse = () => {
    setLoading(true)
    let collectionId =
      courseCollectionId == 'undefined' ||
      courseCollectionId == 'null' ||
      courseCollectionId == null ||
      courseCollectionId == undefined ||
      courseCollectionId == ''
        ? null
        : courseCollectionId

    dispatch(
      aICreatorGenerateCourseAction(
        {
          collectionId: collectionId,
          outlineId: outlineId,
        },
        response => {
          setCourseData({ code: response.courseCode, id: response.couseId })
          let checkProgressInterval = setInterval(() => {
            checkProgress(response.courseId, '', checkProgressInterval)
          }, 1000)
        },
      ),
    )
  }

  const checkProgress = (courseId, courseCode, interval) => {
    dispatch(
      getCourseCreationProgressAction(courseId, response => {
        setProgress(response.cardCreationProgress)
        if (response.cardCreationProgress >= 100) {
          // FINISHED
          clearInterval(interval)
          setLoading(false)
          setFinished(true)
        }
      }),
    )
  }

  const getRecentFile = () => {
    /**
     *
     * @param {} items
     */
    const selectRecentFiles = item => {
      dispatch(aICreatorUploadAttachmentSuccess(item, item.original_file_name))
      dispatch(componentBoxHideAction())
    }
    dispatch(
      componentBoxShowAction(
        new ComponentBoxContent(
          <RecentFiles selectRecentFiles={selectRecentFiles} />,
          {
            hideCloseButton: false,
          },
        ),
      ),
    )
  }

  const handleClickRedirect = type => {
    if ((type = 'Home Page')) {
      history.push('/')
    } else {
      history.push('/pricing')
    }
  }

  const handleBackToHome = () => {
    let collectionId =
      courseCollectionId == 'undefined' ||
      courseCollectionId == 'null' ||
      courseCollectionId == null ||
      courseCollectionId == undefined ||
      courseCollectionId == ''
        ? undefined
        : courseCollectionId
    history.push('/create-course-selection?collectionId=' + collectionId)
  }

  if (limitLoading) {
    return (
      <div
        className={classes.container}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '200px',
        }}
      >
        <CircularProgress />
      </div>
    )
  }

  if (
    UserType[roleType] === 'Basic' ||
    UserType[roleType] === 'AppSumo (Tier 1)' ||
    UserType[roleType] === 'AppSumo (Tier 2)' ||
    UserType[roleType] === 'AppSumo (Tier 3)'
  ) {
    return (
      <div className={classes.container}>
        <BackButton handleBackToHome={handleBackToHome} />
        <Typography className={classes.cardTitle}>
          Upload your resource and let the AI proceed based on it.
        </Typography>
        <UpgradeAiCreatorBanner />
      </div>
    )
  }

  if (currentCredits <= 10) {
    return (
      <div className={classes.container}>
        <Typography className={classes.cardTitle}>
          Upload your resource and let the AI proceed based on it.
        </Typography>
        <div className={classes.limitWarningContainer}>
          <AiCreationLimitModal
            handleClickRedirect={() => {
              handleClickRedirect()
            }}
            refreshesAt={refreshesAt}
            roleType={roleType}
            type={'ai-use-docs'}
          />
        </div>
      </div>
    )
  }
  return (
    <div className={classes.container}>
      {!outline && !loading && (
        <>
          <Typography className={classes.cardTitle}>
            Upload your resource and let the AI proceed based on it.
          </Typography>
          <div className={classes.fileContaienr}>
            <FileUpload
              attachmentLoading={attachmentLoading}
              setAttachmentLoading={setAttachmentLoading}
            />
          </div>

          <CoreTextField
            id="title-input"
            multiline
            rows={1}
            value={description}
            onChange={e => setDescription(e.target.value)}
            fullWidth
            label={placeholder}
            marginTop={true}
          />

          <Settings
            settingsChangeHandler={value => settingsChangeHandler(value)}
          ></Settings>
          <div className={classes.buttonContainer}>
            <CoreButton
              disabled={
                description.length === 0 ||
                attachments.length == 0 ||
                attachmentsToCheck.length != 0
              }
              onClick={generateOutline}
              fullWidth
            >
              Start building
            </CoreButton>
          </div>
        </>
      )}
      {outline && !loading && !finished && (
        <>
          <Outline
            data={outline}
            setData={outline => {
              updateOutline(outline)
            }}
            outlineId={outlineId}
            titles={outline.sections[0]}
          ></Outline>

          <CoreButton
            onClick={() => {
              generateCourse()
            }}
            fullWidth
          >
            Generate Course{' '}
            <Icon icon="mage:coin-a" style={{ margin: '0 4px' }} /> {creditCost}
          </CoreButton>
        </>
      )}

      {loading && (
        <AiLoading
          progress={outline == null ? progressOutline : progress}
        ></AiLoading>
      )}
      {finished && <AiCourseReady courseData={courseData} />}
    </div>
  )
}

export default withStyles(styles)(CreateCourseWithAIUseDocs)
